module.exports = __webpack_public_path__ + "assets/img/download-note-text-dfe47b72.png";